/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./empty.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./empty.component";
var styles_EmptyComponent = [i0.styles];
var RenderType_EmptyComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_EmptyComponent, data: {} });
export { RenderType_EmptyComponent as RenderType_EmptyComponent };
export function View_EmptyComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_EmptyComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-empty", [], null, null, null, View_EmptyComponent_0, RenderType_EmptyComponent)), i1.ɵdid(1, 114688, null, 0, i2.EmptyComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var EmptyComponentNgFactory = i1.ɵccf("app-empty", i2.EmptyComponent, View_EmptyComponent_Host_0, {}, {}, []);
export { EmptyComponentNgFactory as EmptyComponentNgFactory };
